<template>
  <div id="app" :class="['layout', { 'layout--no-sidebar': !hasSidebar }]">
    <Header :showLinks="showLinks" />

    <div class="layout__main">
      <div class="layout__breadcrumbs">
        <slot name="breadcrumbs" />
      </div>

      <div class="layout__sidebar" v-if="hasSidebar">
        <slot name="sidebar" />
      </div>

      <div class="layout__content">
        <slot />
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import "../../icons/"; // TODO - check if icons are necessary
import Header from "./components/Header";
import Footer from "./components/Footer";

import { localizedLink, orgConfig, orgConfiguration } from "@/mixins";

export default {
  mixins: [localizedLink, orgConfig],
  components: {
    Header,
    Footer
  },
  props: {
    showLinks: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    hasSidebar() {
      return !!this.$slots.sidebar;
    }
  },
  metaInfo() {
    if (!this.showLinks) {
      return {
        title: this.$t("portal"),
        titleTemplate: "%s - by Apitalks!",
        meta: [
          {
            vmid: "description",
            name: "description",
            content: this.$t("description")
          },
          {
            vmid: "twitter:description",
            name: "twitter:description",
            content: this.$t("description")
          },
          {
            vmid: "twitter:card",
            name: "twitter:card",
            content: "summary_large_image"
          }
        ]
      };
    }
    // TODO - meta info should be shared across layouts
    return {
      title:
        this.$t("portal") +
        " " +
        orgConfiguration(this.organizationConfig, "organization.name"),
      titleTemplate: "%s - by Apitalks!",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$t("description")
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: this.$t("description")
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: "summary_large_image"
        },
        {
          vmid: "twitter:url",
          name: "twitter:url",
          content: orgConfiguration(this.organizationConfig, "organization.url")
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content:
            this.$t("portal") +
            orgConfiguration(this.organizationConfig, "organization.name")
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: `${
            process.env.VUE_APP_PORTAL_PATH
          }/../tamplete/dev-portal.png`
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            this.$t("portal") +
            orgConfiguration(this.organizationConfig, "organization.name")
        },
        { vmid: "og:type", property: "og:type", content: "website" },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.$t("description")
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: orgConfiguration(this.organizationConfig, "organization.url")
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: `${
            process.env.VUE_APP_PORTAL_PATH
          }/../tamplete/dev-portal.png`
        }
      ],
      htmlAttrs: {
        lang: this.$i18n.locale
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: block;
  background: $--color-white;
}

.layout__main {
  margin: 0 auto;
  padding: 0 $gutter-width / 2;
  max-width: $container-width;
  display: flex;
  align-items: stretch;
  flex-wrap: wrap;
}

.layout__breadcrumbs {
  padding: rem(22) 0 rem(40);
  width: 100%;
  position: relative;
  @include media("<navbar-sm") {
    padding-bottom: rem(10);
  }
}

.layout__sidebar {
  width: 237px;
  border-right: 1px solid $--color-gray-0;
  @include media("<navbar-sm") {
    width: 100%;
    border: none;
  }
}

.layout__content {
  padding-left: 26px;
  width: calc(100% - 237px);
  @include media("<navbar-sm") {
    padding-left: 0;
    width: 100%;
  }
}

.layout--no-sidebar {
  .layout__content {
    padding-left: 0;
    width: 100%;
  }
}
</style>
